package com.yendo.mx.ui.home

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.pager.HorizontalPager
import androidx.compose.foundation.pager.rememberPagerState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowForward
import androidx.compose.material.icons.filled.Search
import androidx.compose.material.icons.filled.Store
import androidx.compose.material.icons.filled.Storefront
import androidx.compose.material.icons.filled.TwoWheeler
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextDecoration
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.zIndex
import coil3.compose.AsyncImage
import coil3.compose.LocalPlatformContext
import coil3.request.ImageRequest
import coil3.request.crossfade
import coil3.size.Size
import com.yendo.mx.models.*
import com.yendo.mx.repository.HomeRepository
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.firestore.firestore
import com.yendo.mx.ui.components.RestauranteRatingBadge
import com.yendo.mx.ui.theme.RosaYendo
import com.yendo.mx.ui.theme.YendoGradient
import com.yendo.mx.utils.AdAnalyticsManager
import com.yendo.mx.utils.getAhora
import kotlinx.coroutines.delay
import org.jetbrains.compose.resources.painterResource
import yendo.shared.generated.resources.*

// 🚀 CONSTANTES DE COLOR INMUTABLES (0ms instanciación en scroll)
private val ColorAzulTransparente = Color(0x1F2196F3)
private val ColorAzulBorde = Color(0x662196F3)
private val ColorNaranjaTransparente = Color(0x1FFF9800)
private val ColorNaranjaBorde = Color(0x66FF9800)
private val ColorOverlayCerrado = Color(0x8C000000)

@Composable
fun BuscadorGlobal(isDark: Boolean, onBuscarClick: () -> Unit) {
    val colorFondoBuscador = if (isDark) Color(0xFF2C2C2E) else Color(0xFFFFFFFF)
    Surface(
        modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp, vertical = 8.dp).height(56.dp).clickable { onBuscarClick() },
        shape = RoundedCornerShape(28.dp), color = colorFondoBuscador,
        border = if (isDark) null else androidx.compose.foundation.BorderStroke(1.dp, Color(0xFFE5E5E5))
    ) {
        Row(modifier = Modifier.fillMaxSize().padding(horizontal = 16.dp), verticalAlignment = Alignment.CenterVertically) {
            Icon(Icons.Default.Search, contentDescription = null, tint = Color.LightGray, modifier = Modifier.size(24.dp))
            Spacer(modifier = Modifier.width(12.dp))
            Text("¿Qué quieres comer hoy?", color = Color.Gray, fontSize = 15.sp, modifier = Modifier.weight(1f))
        }
    }
}

@Composable
fun CategoriasPrincipalesGrid(
    onNavegar: (String) -> Unit,
    tienditaLocal: RestauranteFirebase?,
    comerciosDisponible: Boolean,
    enviosDisponible: Boolean,
    onTienditaClick: (RestauranteFirebase) -> Unit
) {
    val brushTiendita = YendoGradient
    val brushComida = Brush.horizontalGradient(listOf(Color(0xFFFF9800), Color(0xFFFF5722)))
    val brushComercios = Brush.horizontalGradient(listOf(Color(0xFF66BB6A), Color(0xFF43A047)))
    val brushEnvios = Brush.horizontalGradient(listOf(Color(0xFFAB47BC), Color(0xFF5E35B1)))
    
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = 16.dp, vertical = 12.dp),
        verticalArrangement = Arrangement.spacedBy(16.dp)
    ) {
        if (tienditaLocal != null) BotonCategoriaGrande(titulo = "Tiendita YENDO", subtitulo = "Súper, licores y antojos en minutos", fondoBrush = brushTiendita, iconRes = Res.drawable.secc_tiendita, onClick = { onTienditaClick(tienditaLocal) })
        BotonCategoriaGrande("Comida", "Restaurantes y comida rápida", brushComida, iconRes = Res.drawable.secc_comida, onClick = { onNavegar("COMIDA") })
        if (comerciosDisponible) BotonCategoriaGrande("Comercios", "Farmacias, mascotas y más", brushComercios, iconRes = Res.drawable.secc_comercio, onClick = { onNavegar("COMERCIOS") })
        if (enviosDisponible) BotonCategoriaGrande("Envíos", "Mandaditos y paquetería", brushEnvios, iconRes = Res.drawable.secc_envios, onClick = { onNavegar("ENVIOS") })
    }
}

@Composable
fun BotonCategoriaGrande(titulo: String, subtitulo: String, fondoBrush: Brush, iconRes: org.jetbrains.compose.resources.DrawableResource, onClick: () -> Unit) {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .height(100.dp)
            .zIndex(0f)
            .clickable(interactionSource = remember { androidx.compose.foundation.interaction.MutableInteractionSource() }, indication = null) { onClick() }
    ) {
        Surface(
            modifier = Modifier
                .fillMaxWidth()
                .height(100.dp)
                .align(Alignment.Center)
                .zIndex(0f),
            shape = RoundedCornerShape(24.dp),
            color = Color.Transparent
        ) {
            Box(modifier = Modifier.fillMaxSize().background(fondoBrush)) {
                Column(
                    modifier = Modifier
                        .fillMaxWidth(0.60f)
                        .align(Alignment.CenterStart)
                        .padding(start = 20.dp)
                ) {
                    Text(
                        titulo,
                        fontWeight = FontWeight.Black,
                        fontSize = 20.sp,
                        color = Color.White,
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis
                    )
                    Text(
                        subtitulo,
                        fontSize = 12.sp,
                        color = Color.White.copy(alpha = 0.9f),
                        maxLines = 2,
                        lineHeight = 16.sp,
                        overflow = TextOverflow.Ellipsis
                    )
                }
            }
        }

        androidx.compose.foundation.Image(
            painter = painterResource(iconRes),
            contentDescription = titulo,
            modifier = Modifier
                .align(Alignment.CenterEnd)
                .requiredSize(180.dp)
                .offset(x = 20.dp, y = (-12).dp)
                .zIndex(1f),
            contentScale = ContentScale.Fit
        )
    }
}

@Composable
fun FiltrosGlobales(filtros: List<FiltroHome>, colorFondoTarjetas: Color) {
    if (filtros.isEmpty()) return
    var filtroSeleccionado by remember { mutableStateOf("") }
    LazyRow(modifier = Modifier.padding(vertical = 12.dp), contentPadding = PaddingValues(horizontal = 16.dp), horizontalArrangement = Arrangement.spacedBy(12.dp)) {
        items(items = filtros, key = { it.id }) { filtro ->
            val isSelected = filtro.texto == filtroSeleccionado || (filtroSeleccionado.isEmpty() && filtro.orden == 0)
            Surface(
                shape = RoundedCornerShape(25.dp), color = if (isSelected) RosaYendo else colorFondoTarjetas,
                modifier = Modifier.clickable { filtroSeleccionado = filtro.texto }, shadowElevation = 2.dp,
                border = if (!isSelected) androidx.compose.foundation.BorderStroke(1.dp, Color.LightGray.copy(alpha = 0.3f)) else null
            ) {
                Text(text = filtro.texto, modifier = Modifier.padding(horizontal = 20.dp, vertical = 12.dp), fontSize = 14.sp, fontWeight = FontWeight.Bold, color = if (isSelected) Color.White else Color.Black)
            }
        }
    }
}

// 🚀 MEMORIA CACHÉ SÍNCRONA EN TIEMPO REAL PARA ELIMINAR CUALQUIER TIRONEO (0ms)
private val memoriaStatusNegocios = mutableMapOf<String, Boolean>()

@Composable
fun evaluarEstatusCerradoBanner(banner: BannerYendo): Boolean {
    val idTarget = banner.destinoAccion.trim()
    if (idTarget.isBlank() || (banner.tipoAccion != "NEGOCIO" && banner.tipoAccion != "PRODUCTO")) {
        return false
    }

    val cached = memoriaStatusNegocios[idTarget]
    var estaCerrado by remember(banner.id, idTarget, banner.tipoAccion) { 
        mutableStateOf(cached ?: false) 
    }

    LaunchedEffect(banner.id, idTarget, banner.tipoAccion) {
        if (memoriaStatusNegocios.containsKey(idTarget)) {
            estaCerrado = memoriaStatusNegocios[idTarget] ?: false
            return@LaunchedEffect
        }

        val inicioMs = getAhora()
        if (banner.tipoAccion == "NEGOCIO") {
            try {
                val doc = Firebase.firestore.collection("Negocios").document(idTarget).get()
                if (doc.exists) {
                    val rest = doc.data<RestauranteFirebase>()
                    val ahora = getAhora()
                    val estaPausado = rest.operacion.pausadoManualmente && rest.operacion.pausaHasta > ahora
                    val esVisibleOperativo = rest.operacion.visible && rest.operacion.activoComercio && !rest.operacion.bloqueadoPorAdmin && !estaPausado
                    val estaAbiertoHorario = com.yendo.mx.utils.validarRestauranteAbierto(rest)
                    val cerradoResult = !esVisibleOperativo || !estaAbiertoHorario
                    
                    memoriaStatusNegocios[idTarget] = cerradoResult
                    estaCerrado = cerradoResult
                    println("YENDO_PERF_LOG: Status Negocio '$idTarget' cargado en ${getAhora() - inicioMs}ms -> Cerrado: $cerradoResult")
                }
            } catch (e: Exception) { }
        } else if (banner.tipoAccion == "PRODUCTO") {
            try {
                val prodDoc = Firebase.firestore.collection("Productos").document(idTarget).get()
                if (prodDoc.exists) {
                    val prod = prodDoc.data<Producto>()
                    val restDoc = Firebase.firestore.collection("Negocios").document(prod.idRestaurante).get()
                    if (restDoc.exists) {
                        val rest = restDoc.data<RestauranteFirebase>()
                        val ahora = getAhora()
                        val estaPausado = rest.operacion.pausadoManualmente && rest.operacion.pausaHasta > ahora
                        val esVisibleOperativo = rest.operacion.visible && rest.operacion.activoComercio && !rest.operacion.bloqueadoPorAdmin && !estaPausado
                        val estaAbiertoHorario = com.yendo.mx.utils.validarRestauranteAbierto(rest)
                        val cerradoResult = !esVisibleOperativo || !estaAbiertoHorario || !prod.operacion.disponible
                        
                        memoriaStatusNegocios[idTarget] = cerradoResult
                        estaCerrado = cerradoResult
                        println("YENDO_PERF_LOG: Status Producto '$idTarget' cargado en ${getAhora() - inicioMs}ms -> Cerrado: $cerradoResult")
                    }
                }
            } catch (e: Exception) { }
        }
    }

    return estaCerrado
}

@Composable
fun BannersDinamicos(banners: List<BannerYendo>, onAbrirNegocio: (String) -> Unit, onAbrirProducto: (String) -> Unit, onAplicarCupon: (String) -> Unit) {
    if (banners.isEmpty()) return
    val pagerState = rememberPagerState(pageCount = { banners.size })
    val uriHandler = LocalUriHandler.current
    val context = LocalPlatformContext.current

    if (banners.size > 1) {
        LaunchedEffect(banners) {
            while (true) {
                delay(5000)
                if (!pagerState.isScrollInProgress) {
                    val nextPage = (pagerState.currentPage + 1) % banners.size
                    pagerState.animateScrollToPage(nextPage)
                }
            }
        }
    }
    HorizontalPager(state = pagerState, modifier = Modifier.fillMaxWidth().height(140.dp).padding(vertical = 8.dp), contentPadding = PaddingValues(horizontal = 16.dp), pageSpacing = 8.dp) { page ->
        val banner = banners[page]

        val bannerImageRequest: Any? = remember(banner.imagenUrl, context) {
            if (banner.imagenUrl.isNotEmpty()) {
                if (com.yendo.mx.utils.esAndroid()) {
                    ImageRequest.Builder(context)
                        .data(banner.imagenUrl)
                        .size(500, 250)
                        .memoryCachePolicy(coil3.request.CachePolicy.ENABLED)
                        .diskCachePolicy(coil3.request.CachePolicy.ENABLED)
                        .crossfade(false)
                        .build()
                } else {
                    banner.imagenUrl
                }
            } else null
        }

        LaunchedEffect(banner.id) {
            delay(400) // 🚀 DEBOUNCE: Evita tirones de analytics durante scroll rápido
            AdAnalyticsManager.logAdView(
                adId = if (banner.id.isNotBlank()) banner.id else banner.destinoAccion,
                adType = "BANNER_HOME"
            )
        }

        Box(modifier = Modifier.fillMaxSize().clip(RoundedCornerShape(16.dp)).background(if (banner.imagenUrl.isEmpty()) YendoGradient else SolidColor(Color.Transparent)).clickable {
            AdAnalyticsManager.logAdClick(
                adId = if (banner.id.isNotBlank()) banner.id else banner.destinoAccion,
                adType = "BANNER_HOME"
            )

            when (banner.tipoAccion) {
                "NEGOCIO" -> onAbrirNegocio(banner.destinoAccion)
                "PRODUCTO" -> onAbrirProducto(banner.destinoAccion)
                "CUPON" -> onAplicarCupon(banner.destinoAccion)
                "WEB" -> {
                    val urlSegura = if (!banner.destinoAccion.startsWith("http://") && !banner.destinoAccion.startsWith("https://")) "https://${banner.destinoAccion}" else banner.destinoAccion
                    uriHandler.openUri(urlSegura)
                }
            }
        }, contentAlignment = Alignment.Center) {
            if (bannerImageRequest != null) {
                AsyncImage(model = bannerImageRequest, contentDescription = banner.texto, contentScale = ContentScale.Crop, modifier = Modifier.fillMaxSize())
            } else if (banner.texto.isNotEmpty()) {
                Text(text = banner.texto, color = Color.White, fontWeight = FontWeight.ExtraBold, fontSize = 20.sp, textAlign = TextAlign.Center, modifier = Modifier.padding(16.dp))
            }
        }
    }
}

@Composable
fun BannersCuadrados(seccion: SeccionHome, onAbrirNegocio: (String) -> Unit, onAbrirProducto: (String) -> Unit, onAplicarCupon: (String) -> Unit) {
    val uriHandler = LocalUriHandler.current
    val context = LocalPlatformContext.current
    Column(modifier = Modifier.padding(vertical = 12.dp)) {
        if (seccion.titulo.isNotBlank()) {
            Text(text = seccion.titulo, fontWeight = FontWeight.Black, fontSize = 18.sp, modifier = Modifier.padding(start = 16.dp, end = 16.dp, bottom = 12.dp))
        }
        LazyRow(contentPadding = PaddingValues(horizontal = 16.dp), horizontalArrangement = Arrangement.spacedBy(12.dp)) {
            items(seccion.listaBanners) { banner ->
                val bannerImageRequest: Any? = remember(banner.imagenUrl, context) {
                    if (banner.imagenUrl.isNotEmpty()) {
                        if (com.yendo.mx.utils.esAndroid()) {
                            ImageRequest.Builder(context)
                                .data(banner.imagenUrl)
                                .size(250, 250)
                                .memoryCachePolicy(coil3.request.CachePolicy.ENABLED)
                                .diskCachePolicy(coil3.request.CachePolicy.ENABLED)
                                .crossfade(false)
                                .build()
                        } else {
                            banner.imagenUrl
                        }
                    } else null
                }

                LaunchedEffect(banner.id) {
                    delay(400) // 🚀 DEBOUNCE: Evita tirones de analytics durante scroll rápido
                    AdAnalyticsManager.logAdView(
                        adId = if (banner.id.isNotBlank()) banner.id else banner.destinoAccion,
                        adType = "BANNER_SQUARE",
                        context = seccion.titulo
                    )
                }

                Box(modifier = Modifier.size(110.dp).clip(RoundedCornerShape(16.dp)).background(Color.Gray.copy(alpha = 0.1f)).clickable {
                    AdAnalyticsManager.logAdClick(
                        adId = if (banner.id.isNotBlank()) banner.id else banner.destinoAccion,
                        adType = "BANNER_SQUARE",
                        context = seccion.titulo
                    )

                    when (banner.tipoAccion) {
                        "NEGOCIO" -> onAbrirNegocio(banner.destinoAccion)
                        "PRODUCTO" -> onAbrirProducto(banner.destinoAccion)
                        "CUPON" -> onAplicarCupon(banner.destinoAccion)
                        "WEB" -> { val urlSegura = if (!banner.destinoAccion.startsWith("http")) "https://${banner.destinoAccion}" else banner.destinoAccion; uriHandler.openUri(urlSegura) }
                    }
                }) {
                    if (bannerImageRequest != null) {
                        AsyncImage(model = bannerImageRequest, contentDescription = banner.texto, contentScale = ContentScale.Crop, modifier = Modifier.fillMaxSize())
                    }
                }
            }
        }
    }
}

@Composable
fun BannersCuadradosFull(seccion: SeccionHome, onAbrirNegocio: (String) -> Unit, onAbrirProducto: (String) -> Unit, onAplicarCupon: (String) -> Unit) {
    if (seccion.listaBanners.isEmpty()) return
    val pagerState = rememberPagerState(pageCount = { seccion.listaBanners.size })
    val uriHandler = LocalUriHandler.current
    val context = LocalPlatformContext.current

    if (seccion.listaBanners.size > 1) {
        LaunchedEffect(seccion.listaBanners) {
            while (true) {
                delay(5000)
                if (!pagerState.isScrollInProgress) {
                    val nextPage = (pagerState.currentPage + 1) % seccion.listaBanners.size
                    pagerState.animateScrollToPage(nextPage)
                }
            }
        }
    }
    Column(modifier = Modifier.padding(vertical = 12.dp)) {
        if (seccion.titulo.isNotBlank()) { Text(text = seccion.titulo, fontWeight = FontWeight.Black, fontSize = 18.sp, modifier = Modifier.padding(start = 16.dp, end = 16.dp, bottom = 12.dp)) }
        HorizontalPager(state = pagerState, modifier = Modifier.fillMaxWidth(), contentPadding = PaddingValues(horizontal = 16.dp), pageSpacing = 8.dp) { page ->
            val banner = seccion.listaBanners[page]

            val bannerImageRequest: Any? = remember(banner.imagenUrl, context) {
                if (banner.imagenUrl.isNotEmpty()) {
                    if (com.yendo.mx.utils.esAndroid()) {
                        ImageRequest.Builder(context)
                            .data(banner.imagenUrl)
                            .size(500, 500)
                            .memoryCachePolicy(coil3.request.CachePolicy.ENABLED)
                            .diskCachePolicy(coil3.request.CachePolicy.ENABLED)
                            .crossfade(false)
                            .build()
                    } else {
                        banner.imagenUrl
                    }
                } else null
            }

            LaunchedEffect(banner.id) {
                delay(400) // 🚀 DEBOUNCE: Evita tirones de analytics durante scroll rápido
                AdAnalyticsManager.logAdView(
                    adId = if (banner.id.isNotBlank()) banner.id else banner.destinoAccion,
                    adType = "BANNER_FULL",
                    context = seccion.titulo
                )
            }

            Box(modifier = Modifier.fillMaxWidth().aspectRatio(1f).clip(RoundedCornerShape(16.dp)).background(if (banner.imagenUrl.isEmpty()) YendoGradient else SolidColor(Color.Transparent)).clickable {
                AdAnalyticsManager.logAdClick(
                    adId = if (banner.id.isNotBlank()) banner.id else banner.destinoAccion,
                    adType = "BANNER_FULL",
                    context = seccion.titulo
                )

                when (banner.tipoAccion) {
                    "NEGOCIO" -> onAbrirNegocio(banner.destinoAccion)
                    "PRODUCTO" -> onAbrirProducto(banner.destinoAccion)
                    "CUPON" -> onAplicarCupon(banner.destinoAccion)
                    "WEB" -> { val urlSegura = if (!banner.destinoAccion.startsWith("http")) "https://${banner.destinoAccion}" else banner.destinoAccion; uriHandler.openUri(urlSegura) }
                }
            }, contentAlignment = Alignment.Center) {
                if (bannerImageRequest != null) {
                    AsyncImage(model = bannerImageRequest, contentDescription = banner.texto, contentScale = ContentScale.Crop, modifier = Modifier.fillMaxSize())
                } else if (banner.texto.isNotEmpty()) {
                    Text(text = banner.texto, color = Color.White, fontWeight = FontWeight.ExtraBold, fontSize = 28.sp, textAlign = TextAlign.Center, modifier = Modifier.padding(24.dp))
                }
            }
        }
    }
}

// 🚀 CACHÉ EN MEMORIA GLOBAL PERSISTENTE PARA CARROUSELES DE NEGOCIOS Y PRODUCTOS
// Previene el parpadeo y la re-destrucción al hacer scroll hacia abajo y regresar hacia arriba
private val cacheNegociosCarrusel = mutableMapOf<String, List<RestauranteFirebase>>()
private val cacheProductosCarrusel = mutableMapOf<String, List<Producto>>()
private val cacheNegociosParaProductos = mutableMapOf<String, RestauranteFirebase>()

@Composable
fun EnchufeCarruselLargo(seccion: SeccionHome, idZonaActual: String, colorTexto: Color, onVerTodo: (SeccionHome) -> Unit, onRestauranteClick: (RestauranteFirebase) -> Unit) {
    val claveCache = "${seccion.id}_$idZonaActual"
    var restaurantesReales by remember(seccion.id, seccion.negocios, claveCache) {
        mutableStateOf(if (seccion.negocios.isNotEmpty()) seccion.negocios else (cacheNegociosCarrusel[claveCache] ?: emptyList()))
    }
    
    LaunchedEffect(claveCache, seccion.negocios) {
        if (seccion.negocios.isEmpty()) {
            HomeRepository.obtenerNegociosParaSeccion(seccion, idZonaActual).collect {
                cacheNegociosCarrusel[claveCache] = it
                restaurantesReales = it
            }
        }
    }

    val isDark = isSystemInDarkTheme()
    val colorFondoIntegrado = if (isDark) Color(0xFF121212) else Color(0xFFF8F8F8)

    Column(modifier = Modifier.padding(vertical = 12.dp)) {
        Row(
            modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {
            Text(seccion.titulo, fontWeight = FontWeight.Black, fontSize = 20.sp, color = colorTexto)
            Text(
                text = "Ver todo",
                color = RosaYendo,
                fontWeight = FontWeight.Bold,
                fontSize = 14.sp,
                modifier = Modifier.clickable { onVerTodo(seccion) }
            )
        }

        if (restaurantesReales.isEmpty()) {
            LazyRow(contentPadding = PaddingValues(horizontal = 16.dp), horizontalArrangement = Arrangement.spacedBy(16.dp), modifier = Modifier.padding(top = 12.dp)) {
                items(3) {
                    com.yendo.mx.ui.components.RestauranteCardShimmerSkeleton(isDark = isDark, modifier = Modifier.width(220.dp).height(180.dp))
                }
            }
        } else {
            LazyRow(contentPadding = PaddingValues(horizontal = 16.dp), horizontalArrangement = Arrangement.spacedBy(16.dp), modifier = Modifier.padding(top = 12.dp)) {
                items(items = restaurantesReales, key = { it.id }, contentType = { "restaurante_carrusel" }) { restaurante ->
                    LaunchedEffect(restaurante.id) {
                        delay(400) // 🚀 DEBOUNCE: Evita tirones de analytics durante scroll rápido
                        AdAnalyticsManager.logAdView(
                            adId = restaurante.id,
                            adType = "CAROUSEL_REST",
                            context = seccion.titulo
                        )
                    }

                    val context = LocalPlatformContext.current
                    val headerFoto = restaurante.infoPublica.header.ifEmpty { restaurante.infoPublica.logotipo }
                    val imageRequest: Any? = remember(headerFoto, context) {
                        if (headerFoto.isNotEmpty()) {
                            if (com.yendo.mx.utils.esAndroid()) {
                                ImageRequest.Builder(context)
                                    .data(headerFoto)
                                    .size(350, 220)
                                    .memoryCachePolicy(coil3.request.CachePolicy.ENABLED)
                                    .diskCachePolicy(coil3.request.CachePolicy.ENABLED)
                                    .crossfade(false)
                                    .build()
                            } else {
                                headerFoto
                            }
                        } else null
                    }

                    val ahora = remember { getAhora() }
                    val estaPausado = restaurante.operacion.pausadoManualmente && restaurante.operacion.pausaHasta > ahora
                    val esVisibleOperativo = restaurante.operacion.visible && restaurante.operacion.activoComercio && !restaurante.operacion.bloqueadoPorAdmin && !estaPausado
                    val estaAbiertoHorario = remember(restaurante) {
                        if (restaurante.estaAbiertoCloud != null) restaurante.estaAbiertoCloud
                        else com.yendo.mx.utils.validarRestauranteAbierto(restaurante)
                    }
                    val estaOperandoTotal = esVisibleOperativo && estaAbiertoHorario

                    Column(modifier = Modifier.width(220.dp).clickable {
                        AdAnalyticsManager.logAdClick(
                            adId = restaurante.id,
                            adType = "CAROUSEL_REST",
                            context = seccion.titulo
                        )
                        
                        if (esVisibleOperativo) onRestauranteClick(restaurante)
                        else println("⚠️ Negocio inactivo en carrusel")
                    }) {
                        Box {
                            if (imageRequest != null) {
                                AsyncImage(
                                    model = imageRequest,
                                    contentDescription = restaurante.infoPublica.nombre, 
                                    contentScale = ContentScale.Crop,
                                    modifier = Modifier.fillMaxWidth().height(120.dp).clip(RoundedCornerShape(16.dp)).background(colorFondoIntegrado)
                                )
                            }
                            if (restaurante.infoPublica.tienePromo && restaurante.infoPublica.promoTexto.isNotBlank()) {
                                Box(modifier = Modifier.align(Alignment.TopStart).padding(top = 12.dp).background(Color(0xFFFF5722), RoundedCornerShape(topEnd = 8.dp, bottomEnd = 8.dp))) {
                                    Text(restaurante.infoPublica.promoTexto.uppercase(), color = Color.White, fontSize = 10.sp, fontWeight = FontWeight.Black, modifier = Modifier.padding(horizontal = 8.dp, vertical = 4.dp))
                                }
                            }
                            
                            Box(modifier = Modifier.align(Alignment.TopEnd).padding(8.dp)) {
                                com.yendo.mx.ui.components.BotonFavorito(
                                    id = restaurante.id,
                                    tipo = "RESTAURANTE"
                                )
                            }

                            // 🚀 BADGE DE CALIFICACIONES DENTRO DE LA TARJETA / IMAGEN
                            Surface(
                                modifier = Modifier.align(Alignment.BottomEnd).padding(8.dp),
                                shape = RoundedCornerShape(8.dp),
                                color = Color.Transparent
                            ) {
                                RestauranteRatingBadge(reputacion = restaurante.reputacion)
                            }

                            // 🚀 CERRADO / INACTIVO: Opacar la imagen del carrusel con un overlay oscuro y texto centrado CERRADO
                            if (!estaOperandoTotal) {
                                Box(
                                    modifier = Modifier
                                        .fillMaxWidth()
                                        .height(120.dp)
                                        .clip(RoundedCornerShape(16.dp))
                                        .background(ColorOverlayCerrado),
                                    contentAlignment = Alignment.Center
                                ) {
                                    Text(
                                        text = "CERRADO",
                                        color = Color.White,
                                        fontSize = 11.sp,
                                        fontWeight = FontWeight.Black,
                                        letterSpacing = 1.sp,
                                        textAlign = TextAlign.Center
                                    )
                                }
                            }
                        }

                        // 1. BADGES DUALES DE ENVÍO Y RECOGER (ARRIBA DEL NOMBRE)
                        val configZona = com.yendo.mx.utils.ConfigManager.configActiva
                        val deliveryGlobalZonaActivo = (configZona?.logistica?.delivery_activo ?: true) && com.yendo.mx.utils.LogisticaUtils.estaPlataformaAbierta(configZona)
                        val permiteEnvio = estaOperandoTotal && restaurante.operacion.deliveryActivo && (deliveryGlobalZonaActivo || restaurante.operacion.tieneFlotaPropiaActiva)
                        val permiteRecoger = estaOperandoTotal && restaurante.operacion.pickupActivo

                        Row(
                            horizontalArrangement = Arrangement.spacedBy(4.dp),
                            verticalAlignment = Alignment.CenterVertically,
                            modifier = Modifier.padding(top = 6.dp)
                        ) {
                            if (permiteEnvio) {
                                Surface(
                                    color = ColorAzulTransparente,
                                    shape = RoundedCornerShape(6.dp),
                                    border = BorderStroke(0.5.dp, ColorAzulBorde)
                                ) {
                                    Row(
                                        modifier = Modifier.padding(horizontal = 5.dp, vertical = 2.dp),
                                        verticalAlignment = Alignment.CenterVertically
                                    ) {
                                        Icon(
                                            imageVector = Icons.Default.TwoWheeler,
                                            contentDescription = "Envío",
                                            tint = Color(0xFF2196F3),
                                            modifier = Modifier.size(10.dp)
                                        )
                                        Spacer(Modifier.width(3.dp))
                                        Text(
                                            text = "Envío",
                                            fontSize = 9.sp,
                                            fontWeight = FontWeight.Bold,
                                            color = Color(0xFF2196F3)
                                        )
                                    }
                                }
                            }

                            if (permiteRecoger) {
                                Surface(
                                    color = ColorNaranjaTransparente,
                                    shape = RoundedCornerShape(6.dp),
                                    border = BorderStroke(0.5.dp, ColorNaranjaBorde)
                                ) {
                                    Row(
                                        modifier = Modifier.padding(horizontal = 5.dp, vertical = 2.dp),
                                        verticalAlignment = Alignment.CenterVertically
                                    ) {
                                        Icon(
                                            imageVector = Icons.Default.Storefront,
                                            contentDescription = "Recoger",
                                            tint = Color(0xFFFF9800),
                                            modifier = Modifier.size(10.dp)
                                        )
                                        Spacer(Modifier.width(3.dp))
                                        Text(
                                            text = "Recoger",
                                            fontSize = 9.sp,
                                            fontWeight = FontWeight.Bold,
                                            color = Color(0xFFFF9800)
                                        )
                                    }
                                }
                            }
                        }

                        // 2. NOMBRE DEL NEGOCIO (ABAJO DE LOS CHIPS)
                        Text(
                            text = restaurante.infoPublica.nombre,
                            fontWeight = FontWeight.Bold,
                            fontSize = 14.sp,
                            minLines = 2,
                            maxLines = 2,
                            lineHeight = 18.sp,
                            overflow = TextOverflow.Ellipsis,
                            modifier = Modifier.padding(top = 4.dp),
                            color = colorTexto
                        )
                    }
                }
                item {
                    Box(
                        modifier = Modifier
                            .height(180.dp)
                            .width(100.dp)
                            .clickable { onVerTodo(seccion) },
                        contentAlignment = Alignment.Center
                    ) {
                        Column(horizontalAlignment = Alignment.CenterHorizontally) {
                            Surface(
                                shape = CircleShape,
                                color = RosaYendo.copy(alpha = 0.1f),
                                modifier = Modifier.size(44.dp)
                            ) {
                                Icon(Icons.AutoMirrored.Filled.ArrowForward, null, tint = RosaYendo, modifier = Modifier.padding(10.dp))
                            }
                            Spacer(Modifier.height(8.dp))
                            Text("Ver todos", color = RosaYendo, fontWeight = FontWeight.Bold, fontSize = 13.sp)
                        }
                    }
                }
            }
        }
    }
}

@Composable
fun EnchufeCarruselCuadrado(seccion: SeccionHome, idZonaActual: String, colorTexto: Color, onVerTodo: (SeccionHome) -> Unit, onProductoClick: (Producto) -> Unit) {
    val claveCache = "${seccion.id}_$idZonaActual"
    var productosReales by remember(seccion.id, seccion.productos, claveCache) {
        mutableStateOf(if (seccion.productos.isNotEmpty()) seccion.productos else (cacheProductosCarrusel[claveCache] ?: emptyList()))
    }
    val todosRestaurantes by com.yendo.mx.repository.RestauranteRepository.obtenerRestaurantes().collectAsState(initial = emptyList())
    val mapaRestaurantes = remember(todosRestaurantes) { 
        val map = todosRestaurantes.associateBy { it.id }
        cacheNegociosParaProductos.putAll(map)
        map
    }

    LaunchedEffect(claveCache, seccion.productos) {
        if (seccion.productos.isEmpty()) {
            HomeRepository.obtenerProductosParaSeccion(seccion, idZonaActual).collect {
                cacheProductosCarrusel[claveCache] = it
                productosReales = it
            }
        }
    }

    val isDark = isSystemInDarkTheme()
    val colorFondoIntegrado = if (isDark) Color(0xFF121212) else Color(0xFFF8F8F8)

    Column(modifier = Modifier.padding(vertical = 12.dp)) {
        Row(
            modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {
            Text(seccion.titulo, fontWeight = FontWeight.Black, fontSize = 20.sp, color = colorTexto)
            Text(
                text = "Ver todo",
                color = RosaYendo,
                fontWeight = FontWeight.Bold,
                fontSize = 14.sp,
                modifier = Modifier.clickable { onVerTodo(seccion) }
            )
        }

        if (productosReales.isEmpty()) {
            LazyRow(contentPadding = PaddingValues(horizontal = 16.dp), horizontalArrangement = Arrangement.spacedBy(16.dp), modifier = Modifier.padding(top = 12.dp)) {
                items(3) {
                    com.yendo.mx.ui.components.RestauranteCardShimmerSkeleton(isDark = isDark, modifier = Modifier.width(130.dp).height(150.dp))
                }
            }
        } else {
            LazyRow(contentPadding = PaddingValues(horizontal = 16.dp), horizontalArrangement = Arrangement.spacedBy(16.dp), modifier = Modifier.padding(top = 12.dp)) {
                items(items = productosReales, key = { it.id }, contentType = { "producto_carrusel" }) { producto ->
                    val idRest = producto.idRestaurante
                    val negocio = mapaRestaurantes[idRest] ?: cacheNegociosParaProductos[idRest]

                    LaunchedEffect(idRest) {
                        if (idRest.isNotBlank() && !mapaRestaurantes.containsKey(idRest) && !cacheNegociosParaProductos.containsKey(idRest)) {
                            try {
                                val doc = Firebase.firestore.collection("Negocios").document(idRest).get()
                                if (doc.exists) {
                                    val rest = doc.data<RestauranteFirebase>().copy(id = doc.id)
                                    cacheNegociosParaProductos[idRest] = rest
                                }
                            } catch (e: Exception) {
                                println("🚨 Error cargando negocio para producto carrusel: ${e.message}")
                            }
                        }
                    }

                    LaunchedEffect(producto.id) {
                        delay(400) // 🚀 DEBOUNCE: Evita tirones de analytics durante scroll rápido
                        AdAnalyticsManager.logAdView(
                            adId = producto.id,
                            adType = "CAROUSEL_PROD",
                            context = seccion.titulo
                        )
                    }

                    val context = LocalPlatformContext.current
                    val productoImageRequest: Any? = remember(producto.foto, context) {
                        if (producto.foto.isNotEmpty()) {
                            if (com.yendo.mx.utils.esAndroid()) {
                                ImageRequest.Builder(context)
                                    .data(producto.foto)
                                    .size(250, 250)
                                    .memoryCachePolicy(coil3.request.CachePolicy.ENABLED)
                                    .diskCachePolicy(coil3.request.CachePolicy.ENABLED)
                                    .crossfade(false)
                                    .build()
                            } else {
                                producto.foto
                            }
                        } else null
                    }

                    val ahora = remember { getAhora() }
                    val esVisibleNegocio = negocio?.let { it.operacion.visible && it.operacion.activoComercio && !it.operacion.bloqueadoPorAdmin && !(it.operacion.pausadoManualmente && it.operacion.pausaHasta > ahora) } ?: true
                    val estaAbiertoNegocio = negocio?.let {
                        if (it.estaAbiertoCloud != null) it.estaAbiertoCloud
                        else com.yendo.mx.utils.validarRestauranteAbierto(it)
                    } ?: true
                    val negocioCerrado = !esVisibleNegocio || !estaAbiertoNegocio

                    Column(modifier = Modifier.width(130.dp).clickable {
                        AdAnalyticsManager.logAdClick(
                            adId = producto.id,
                            adType = "CAROUSEL_PROD",
                            context = seccion.titulo
                        )
                        
                        onProductoClick(producto) 
                    }) {
                        Box {
                            if (productoImageRequest != null) {
                                AsyncImage(
                                    model = productoImageRequest,
                                    contentDescription = producto.nombre, 
                                    contentScale = ContentScale.Crop,
                                    modifier = Modifier.size(130.dp).clip(RoundedCornerShape(16.dp)).background(colorFondoIntegrado)
                                )
                            }
                            if (!producto.operacion.disponible || negocioCerrado) {
                                Box(modifier = Modifier.size(130.dp).clip(RoundedCornerShape(16.dp)).background(Color.Black.copy(alpha = 0.55f)), contentAlignment = Alignment.Center) {
                                    Text(
                                        text = if (!producto.operacion.disponible) "NO DISPONIBLE" else "LOCAL CERRADO", 
                                        color = Color.White, 
                                        fontSize = 10.sp, 
                                        fontWeight = FontWeight.Black, 
                                        textAlign = TextAlign.Center
                                    )
                                }
                            }
                            if (producto.infoProducto.tipoPromocion.isNotBlank() && producto.infoProducto.tipoPromocion.uppercase() != "NINGUNA" || producto.infoProducto.precioOriginal > producto.precio) {
                                Box(modifier = Modifier.align(Alignment.TopStart).padding(8.dp).background(Color(0xFFE53935), RoundedCornerShape(8.dp))) {
                                    val textoEtiqueta = when {
                                        producto.infoProducto.tipoPromocion.uppercase() == "DOS_POR_UNO" -> "2x1"
                                        producto.infoProducto.tipoPromocion.uppercase() == "TRES_POR_DOS" -> "3x2"
                                        producto.infoProducto.tipoPromocion.uppercase() == "REGALO" -> "🎁 + REGALO"
                                        producto.infoProducto.precioOriginal > producto.precio -> {
                                            val descuentoPorcentaje = ((1 - (producto.precio / producto.infoProducto.precioOriginal)) * 100).toInt()
                                            "-$descuentoPorcentaje%"
                                        }
                                        else -> "PROMO"
                                    }
                                    Text(text = textoEtiqueta, color = Color.White, fontSize = 10.sp, fontWeight = FontWeight.Black, modifier = Modifier.padding(horizontal = 6.dp, vertical = 2.dp))
                                }
                            }

                            Box(modifier = Modifier.align(Alignment.TopEnd).padding(4.dp)) {
                                com.yendo.mx.ui.components.BotonFavorito(
                                    id = producto.id,
                                    tipo = "PRODUCTO",
                                    idRestauranteAsociado = producto.idRestaurante,
                                    size = 28.dp,
                                    iconSize = 16.dp
                                )
                            }
                        }
                        // 1. PRECIO
                        Row(verticalAlignment = Alignment.CenterVertically, modifier = Modifier.padding(top = 6.dp)) {
                            Text("$${producto.precio}", color = RosaYendo, fontWeight = FontWeight.Black, fontSize = 13.sp)
                            if (producto.infoProducto.precioOriginal > producto.precio) {
                                Spacer(Modifier.width(4.dp))
                                Text("$${producto.infoProducto.precioOriginal}", color = Color.Gray, fontSize = 10.sp, textDecoration = TextDecoration.LineThrough)
                            }
                        }

                        // 2. NEGOCIO (Arriba del nombre y abajo del precio)
                        val logoNegocio = producto.logoRestaurante.ifBlank { negocio?.infoPublica?.logotipo ?: "" }
                        val nombreNegocio = producto.nombreRestaurante.ifBlank { negocio?.infoPublica?.nombre ?: "" }
                        if (nombreNegocio.isNotBlank()) {
                            Row(
                                verticalAlignment = Alignment.CenterVertically,
                                modifier = Modifier.padding(top = 2.dp)
                            ) {
                                if (logoNegocio.isNotEmpty()) {
                                    AsyncImage(
                                        model = ImageRequest.Builder(LocalPlatformContext.current).data(logoNegocio).crossfade(false).build(),
                                        contentDescription = nombreNegocio,
                                        contentScale = ContentScale.Crop,
                                        modifier = Modifier.size(14.dp).clip(CircleShape).background(Color.LightGray.copy(alpha = 0.3f))
                                    )
                                } else {
                                    Icon(
                                        imageVector = Icons.Default.Store,
                                        contentDescription = null,
                                        tint = Color.Gray,
                                        modifier = Modifier.size(14.dp)
                                    )
                                }
                                Spacer(Modifier.width(4.dp))
                                Text(
                                    text = nombreNegocio,
                                    fontSize = 11.sp,
                                    fontWeight = FontWeight.Medium,
                                    color = Color.Gray,
                                    maxLines = 1,
                                    overflow = TextOverflow.Ellipsis
                                )
                            }
                        }

                        // 3. NOMBRE DEL PRODUCTO
                        Text(
                            text = producto.nombre,
                            fontWeight = FontWeight.Bold,
                            fontSize = 13.sp,
                            color = colorTexto,
                            modifier = Modifier.padding(top = 2.dp),
                            minLines = 2,
                            maxLines = 2,
                            lineHeight = 17.sp,
                            overflow = TextOverflow.Ellipsis
                        )
                    }
                }
                item {
                    Box(
                        modifier = Modifier
                            .height(180.dp)
                            .width(100.dp)
                            .clickable { onVerTodo(seccion) },
                        contentAlignment = Alignment.Center
                    ) {
                        Column(horizontalAlignment = Alignment.CenterHorizontally) {
                            Surface(
                                shape = CircleShape,
                                color = RosaYendo.copy(alpha = 0.1f),
                                modifier = Modifier.size(44.dp)
                            ) {
                                Icon(Icons.AutoMirrored.Filled.ArrowForward, null, tint = RosaYendo, modifier = Modifier.padding(10.dp))
                            }
                            Spacer(Modifier.height(8.dp))
                            Text("Ver todos", color = RosaYendo, fontWeight = FontWeight.Bold, fontSize = 13.sp)
                        }
                    }
                }
            }
        }
    }
}
